// Constants
const FOCUSABLE_ELEMENT_SELECTORS = "a, button, input"
const DOM = {
  MENU_BUTTONS: document.querySelectorAll(".js-menu-button"), // Allow for multiple in case we add a second button on the bottom of the page,
  NAV_MENU: document.querySelector(".js-nav-menu"),
  HEADER: document.querySelector(".js-shy-nav"),
  BODY: document.body,
}
const CLASSNAMES = {
  ACTIVE: "active",
  NO_SCROLL: "no-scroll",
}
// Helper functions
const trapFocus = (el, selectors = FOCUSABLE_ELEMENT_SELECTORS) => {
  const focusableElements = el.querySelectorAll(selectors)
  const firstFocusableEl = focusableElements[0],
    lastFocusableEl = focusableElements[focusableElements.length - 1]

  firstFocusableEl.focus()

  const keyboardHandler = (e) => {
    if (e.keyCode === 9) {
      //Rotate Focus
      if (e.shiftKey && document.activeElement === firstFocusableEl) {
        e.preventDefault()
        lastFocusableEl.focus()
      } else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
        e.preventDefault()
        firstFocusableEl.focus()
      }
    }
  }
  el.addEventListener("keydown", keyboardHandler)
}

const toggleAriaExpanded = (el) => {
  let expanded = el.getAttribute("aria-expanded")
  el.setAttribute("aria-expanded", expanded === "false" ? "true" : "false")
}

const hideFromTabbing = (elems) => {
  elems.forEach((item) => {
    item.setAttribute("aria-hidden", "true")
    item.setAttribute("tabindex", "-1")
  })
}

const unHideFromTabbing = (elems) => {
  elems.forEach((item) => {
    item.setAttribute("aria-hidden", "false")
    item.setAttribute("tabindex", "0")
  })
}

const closeOnEsc = (event) => {
  if (event.keyCode === 27) {
    removeCloseNavClickListeners()
    closeMenu()
  }
}

const addCloseNavClickListeners = () => {
  document.addEventListener("keydown", closeOnEsc)
}

const removeCloseNavClickListeners = () => {
  document.removeEventListener("keydown", closeOnEsc)
}

// Controls navigation JS
const closeMenu = () => {
  DOM.NAV_MENU.classList.remove(CLASSNAMES.ACTIVE)
  DOM.BODY.classList.remove(CLASSNAMES.NO_SCROLL)
  hideFromTabbing(DOM.NAV_MENU.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS))
  removeCloseNavClickListeners()
}

const openMenu = () => {
  DOM.NAV_MENU.classList.add(CLASSNAMES.ACTIVE)
  DOM.BODY.classList.add(CLASSNAMES.NO_SCROLL)
  unHideFromTabbing(DOM.NAV_MENU.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS))
  trapFocus(DOM.NAV_MENU)
  addCloseNavClickListeners()
  DOM.HEADER.style.transform = "translateY(0px)" // Prevent shy nav from moving header up on mobile nav
}

const handleNavClick = () => {
  DOM.MENU_BUTTONS.forEach((item) => {
    toggleAriaExpanded(item)
  })
  if (DOM.NAV_MENU.classList.contains(CLASSNAMES.ACTIVE)) {
    closeMenu()
  } else {
    openMenu()
  }
}

DOM.MENU_BUTTONS.forEach((item) => {
  item.addEventListener("click", handleNavClick)
})

// Shy nav
const headerHeight = DOM.HEADER.offsetHeight
let scrollPosition = 0
let timeout = false

window.addEventListener("scroll", function () {
  if (!timeout) {
    window.requestAnimationFrame(function () {
      const scrollTop = window.pageYOffset
      let scrollDown = false
      DOM.HEADER.classList.add("scrolling")

      if (scrollTop <= 0) {
        DOM.HEADER.classList.remove("scrolling")
      }

      if (scrollTop > scrollPosition) {
        scrollDown = true
      } else {
        scrollDown = false
      }

      scrollPosition = window.scrollY
      animateHeader(scrollPosition, scrollDown)
      timeout = false
    })

    timeout = true
  }
})

function animateHeader(scrollPos, scrollDownBoolean) {
  if (scrollPos > headerHeight * 2 && scrollDownBoolean) {
    DOM.HEADER.style.transform = `translateY(-${headerHeight}px)`
  } else {
    DOM.HEADER.style.transform = "translateY(0px)"
  }
}
